import React from 'react';
export function ValueTable() {
  return null;
}